module.exports = __webpack_public_path__ + "static/media/buildingsWIRELESS.e2c67ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/shared/buildingsWIRELESS.png
// module id = 75
// module chunks = 0